import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";

@Component({
    selector: 'kan-remove-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanRemoveDialog {

    constructor(private dialogRef: MatDialogRef<kanRemoveDialog>, @Inject(MAT_DIALOG_DATA) private data: any) {
    }

    public remove(event: any) {
        this.dialogRef.close('remove')
    }
}



// WEBPACK FOOTER //
// ./src/modules/common/dialogs/remove-dialog/component.ts